var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSortType2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8,
    height: 18,
    viewBox: "0 0 8 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_33376",
    "data-name": "Group 33376",
    transform: "translate(-1053.5 -204.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32241",
    "data-name": "Group 32241",
    transform: "translate(1260.5 1228.5) rotate(180)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17",
    "data-name": "Rectangle 17",
    width: 8,
    height: 8,
    transform: "translate(199 1016)",
    fill: "none",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M1304.53,231.558l2.986,3,2.986-3",
    transform: "translate(-1104.516 786.942)",
    fill: "none",
    stroke: "#5e6278",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_32242",
    "data-name": "Group 32242",
    transform: "translate(854.5 -801.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17-2",
    "data-name": "Rectangle 17",
    width: 8,
    height: 8,
    transform: "translate(199 1016)",
    fill: "none",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33-2",
    "data-name": "Path 33",
    d: "M1304.53,231.558l2.986,3,2.986-3",
    transform: "translate(-1104.516 786.942)",
    fill: "none",
    stroke: "#5e6278",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortType2);
export default __webpack_public_path__ + "static/media/sort-type-2.cd764376.svg";
export { ForwardRef as ReactComponent };